/*
 * Many of the _content.jsx fields store text as either a string or JSX, for example an array of <p> tags.
 * This poses an edge case where paragraph tags can become nested, which is invalid HTML.
 * To prevent this error from happening, this function checks to see if the content is either a string or JSX.
 * Then, it renders the content accordingly.
 */

import * as React from 'react';

export default function renderJsxOrParagraphTag(content) {
  // Render the content inside a <p> tag if it's a string
  if (typeof content === 'string') {
    return <p>{content}</p>;
  }

  // Render the JSX if the content is an array with the JSX objects
  if (
    Array.isArray(content) &&
    content[0].$$typeof === Symbol.for('react.element')
  ) {
    return content;
  }

  // Render the JSX if the content is a JSX object
  if (
    typeof content === 'object' &&
    content.$$typeof === Symbol.for('react.element')
  ) {
    return content;
  }

  throw new Error(
    'The argument passed to the function renderJsxOrParagraphTag() is neither a string or a JSX object.'
  );
}
